import PropertyPanel from '../widgets/PropertyPanel.js';

/**
 * WebpagePropertyPanel - UI for webpage/iframe material properties
 */
export default class WebpagePropertyPanel extends PropertyPanel {
  render(initialData = {}) {
    this.clear();

    // Webpage URL subsection
    const urlSection = this.builder.createAnimatedSubsection('Webpage URL', 1, false);
    const urlInput = this.builder.createInput(initialData.url || '', 'text');
    urlInput.placeholder = 'Enter webpage URL or local path...';
    urlInput.className = 'gui-input gui-input-full';
    urlInput.addEventListener('input', () => {
      if (this.onChange) this.onChange();
    });
    urlSection.body.appendChild(this.builder.createRow('URL', urlInput, true));
    this.container.appendChild(urlSection.subsection);
    this.controls.urlInput = urlInput;

    // Webpage presets subsection
    const presetSection = this.builder.createAnimatedSubsection('Presets', 1, false);

    const presets = [
      { value: window.location.href, label: 'This App (Inception)' },
      { value: 'https://3merillon.com', label: '3merillon.com' },
      { value: 'https://rmt.world', label: 'RMT Compose' },
      { value: 'webpage-face-demo.html', label: 'Interactive Demo' },
      { value: 'https://www.wikipedia.org/', label: 'Wikipedia' },
      { value: 'about:blank', label: 'Blank Page' }
    ];

    const presetSelector = this.builder.createPresetSelector(presets, (preset) => {
      urlInput.value = preset.value;
      if (this.onChange) this.onChange();
    });

    presetSection.body.appendChild(presetSelector.container);
    this.container.appendChild(presetSection.subsection);

    // Interactive checkbox
    const interactive = this.addCheckbox('Interactive', initialData.interactive !== false);
    interactive.checkbox.addEventListener('change', () => {
      if (this.onChange) this.onChange();
    });
    this.controls.interactive = interactive;

    // Add help text about interactivity
    const helpText = document.createElement('div');
    helpText.className = 'gui-help-text';
    helpText.textContent = 'When enabled, iframe content is clickable. Use Shift+Click to select the face instead.';
    helpText.style.cssText = 'font-size: 10px; color: #888; margin-top: 4px; padding: 0 4px;';
    this.container.appendChild(helpText);

    // Note about single webpage limitation
    const noteSection = this.builder.createAnimatedSubsection('Notes', 1, false);
    const noteText = document.createElement('div');
    noteText.className = 'gui-help-text';
    noteText.innerHTML = `
      <strong style="color: #5cb85c;">DOM-stable rendering:</strong><br>
      The iframe stays in place while other elements reorder around it, preventing reload during camera movement.<br>
      <br>
      <strong style="color: #f0ad4e;">Limitation:</strong> Only <strong>one</strong> webpage face per scene is supported. Additional webpage faces will reload on camera changes.<br>
      <br>
      <strong style="color: #5bc0de;">CORS/External Sites:</strong><br>
      Most external websites block iframe embedding. Same-origin pages (like "This App") always work. For external content, try sites that allow embedding or use a CORS proxy.
    `;
    noteText.style.cssText = 'font-size: 10px; color: #aaa; padding: 4px; line-height: 1.4;';
    noteSection.body.appendChild(noteText);
    this.container.appendChild(noteSection.subsection);

    // Opacity
    const opacitySlider = this.addSlider('Opacity', 0, 1, 0.01, initialData.opacity || 1, (val) => {
      if (this.onChange) this.onChange();
    });
    this.controls.opacitySlider = opacitySlider;
  }

  getData() {
    return {
      type: 'webpage',
      url: this.controls.urlInput.value,
      interactive: this.controls.interactive.checkbox.checked,
      opacity: parseFloat(this.controls.opacitySlider.slider.value)
    };
  }

  setData(data) {
    if (data.webpage) this.controls.urlInput.value = data.webpage;
    if (data.url) this.controls.urlInput.value = data.url;
    if (data.webpageInteractive !== undefined) this.controls.interactive.checkbox.checked = data.webpageInteractive;
    if (data.interactive !== undefined) this.controls.interactive.checkbox.checked = data.interactive;
    if (data.opacity !== undefined) {
      this.controls.opacitySlider.slider.value = data.opacity;
      this.controls.opacitySlider.valueInput.value = data.opacity;
    }
  }
}
